import { WIDGET_KEYS } from "./WidgetKeys.jsx";
import {
  defaultGroupRenderer as groupRenderer,
  EntityMainNameDefault,
  lineThroughRenderer,
  linkifyText
} from "../utils/utils.jsx";
import { GRID_FIELDS_TO_OPEN_EDITOR } from "./OtherKeys.jsx";
import { DateHelper } from "@bryntum/schedulerpro";


export const REMINDER_VIEW_COLUMN = [
  {
    id: "recipients",
    type: WIDGET_KEYS.reminderRecipientsColumn,
    editor: false,
    cellCls: "swivu-recipients-cell flex gap-[0.5em]",
  },
  {
    id: "status",
    text: "Status",
    field: "status",
    editor: false,
    groupRenderer,
  },
  {
    id: "reminder-name",
    text: "Entity Name",
    filterType: "string",
    field: GRID_FIELDS_TO_OPEN_EDITOR.ENTITY_NAME,
    flex: 1,
    editor: false,
    type: WIDGET_KEYS.swivuSortColumn,
    // Todo: use EntityMainNameColumn
    renderer: ({ value, record }) => EntityMainNameDefault(lineThroughRenderer(value, record.archived)),
    groupRenderer,
  },
  {
    id: "reminder-description",
    text: "Description",
    type: WIDGET_KEYS.swivuSortColumn,
    field: "description",
    flex: 1,
    cellCls: "!overflow-hidden",
    renderer: ({ record, value }) => linkifyText(lineThroughRenderer(value, record.archived)),
    groupRenderer,
  },
  {
    id: "reminder-alert-date",
    type: "date",
    field: "_alertDate",
    text: "Date",
    flex: 1,
    editor: {
      keepTime: true,
      required: true,
    },
    groupRenderer,
    finalizeCellEdit: ({ value }) => {
      if (DateHelper.isBefore(value, new Date())) {
        return "Cannot set alert date/time in the past"
      }
      return true;
    }
  },
  {
    id: "reminder-alert-time",
    type: "time",
    // filterType is not really required at the moment, however to make this column future-proof we
    // need to explicitly provide our special filter type
    filterType: "_swivu_time",
    field: "_alertTime",
    text: "Time",
    flex: 1,
    editor: {
      keepDate: true,
      required: true,
    },
    groupRenderer,
    finalizeCellEdit: ({ value }) => {
      if (DateHelper.isBefore(value, new Date())) {
        return "Cannot set alert date/time in the past"
      }
      return true;
    }
  },
  {
    id: "recurringInterval",
    type: WIDGET_KEYS.recurringIntervalColumn,
  },
  {
    id: "repeatCount",
    field: "repeatCount",
    text: "Recurring Count",
    align: "center",
    flex: 1,
    minWidth: 100,
    min: 0,
    type: "number",
    editor: {
      required: true,
    },
    finalizeCellEdit: ({ value, record }) => {
      if (value === 0) {
        return "Cannot set repeat count to zero, Set recurring to Never";
      }
      else if (value < record.releasedCount) {
        return "New repeat count should be greater than the released reminders"
      }
      return true;
    }
  }
]
